<div class="flex w-full justify-between">
	<a
		href="https://docs.trade.polynomial.fi/trade/trading-guide"
		target="_blank"
		rel="noreferrer"
		class="text-fx-pink text-xs flex gap-2"
		><span class="pt-0.5"> Trading Guide</span>
		<img src="pink-question-help.svg" alt="etherscan" class="cursor-pointer w-5 h-5" />
	</a>
	<a
		href="https://discord.gg/polynomial"
		target="_blank"
		rel="noreferrer"
		class="text-fx-grey-400 text-xs flex gap-2"
		><span class="pt-0.5"> Support </span>
		<img src="link-grey.png" alt="etherscan" class="cursor-pointer w-5 h-5" />
	</a>
</div>
